import React, { createContext, useContext, useEffect, useState } from "react";
import { useStaticQuery, graphql } from "gatsby"; 

const ContentContext = createContext();

export const useContent = () => useContext(ContentContext);

export const ContentProvider = ({ children }) => {
    const contactData = useStaticQuery(graphql`
        query {
            contentfulPage(id: {eq: "322043b1-fd84-5f71-ad1a-799820ead418"}) {
                id
                slug
                contactPageWhySavor
            }
        }
    `)

    const [isModal, setModal] = useState(false)
    const [modalContent, setModalContent] = useState({})

    const [formPopup, setFormPopup] = useState(false)
    const [formPopupContent, setFormPopupContent] = useState({})
    
    const [clickedImageUrl, setClickedImageUrl] = useState(null)
    // const [contactSavorReasonTitle, setContactSavorReasonTitle] = useState('')
    const [contactSavorReasons, setContactSavorReasons] = useState([])

    useEffect(() => {
        if (contactData && contactData.contentfulPage && Array.isArray(contactData.contentfulPage.contactPageWhySavor)) {
            setContactSavorReasons(contactData.contentfulPage.contactPageWhySavor);
        }
        // if (contactData && contactData.contentfulPage && contactData.contentfulPage.contactPageSavorReasonTitle) {
        //     setContactSavorReasonTitle(contactData.contentfulPage.contactPageSavorReasonTitle);
        // }
    }, [contactData]);
    return (
        <ContentContext.Provider value={{ 
            isModal, setModal, 
            clickedImageUrl, setClickedImageUrl,
            contactSavorReasons, setContactSavorReasons,
            modalContent, setModalContent,
            // contactSavorReasonTitle, setContactSavorReasonTitle,

            formPopup, setFormPopup,
            formPopupContent, setFormPopupContent
        }}>
        {children}
        </ContentContext.Provider>
    );
};